import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { AppLanguage, LanguagePipe } from '@aston/foundation';
import { ITenantInfos, IUserSession } from 'apps/debtor-portal/src/app/authentication-module/models';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

import * as RoutesDefinitions from '../../../routes-definitions';

@Component({
	selector: 'layout-header',
	templateUrl: './layout-header.component.html',
	imports: [NgbDropdownModule, RouterLinkActive, TranslateModule, RouterLink, LanguagePipe]
})
export class LayoutHeaderComponent implements OnChanges {
	@Input() isAuthenticated = false;
	@Input() userSession: IUserSession;
	@Input() tenant: ITenantInfos;
	@Input() currentLanguage: AppLanguage;
	@Input() currentActionId: number;
	@Output() lang = new EventEmitter<AppLanguage>();
	@Output() logout = new EventEmitter<void>();

	accountingListRoutePath = RoutesDefinitions.getDunningAccountingFullPath(null);
	dunningActionsListRoutePath = RoutesDefinitions.getDunningActionsListFullPath();
	invoicingListRoutePath = RoutesDefinitions.getDunningInvoicingFullPath();
	requestsListRoutePath = RoutesDefinitions.getRequestsListFullPath();
	AppLanguage = AppLanguage;

	ngOnChanges() {
		this.accountingListRoutePath = RoutesDefinitions.getDunningAccountingFullPath(this.currentActionId);
	}

	onLogout() {
		this.logout.emit();
	}

	setLanguage(lang: AppLanguage) {
		this.lang.emit(lang);
	}
}
